import { Vue, Options } from "vue-class-component";
import NavBarComponent from "./components/nav-bar/nav-bar.component.vue";
import { authModule } from "./store/modules/auth.module";

@Options({
  components: {
    "nav-bar": NavBarComponent,
  },
})
export default class AppComponent extends Vue {
  
  get loggedIn() {
    return authModule.isLoggedIn;
  }

  onLogOut() {
    authModule.getLogout();
    this.$router.push({ name: "Login" });
  }
}
